import { render, staticRenderFns } from "./BaggageInformationApp.vue?vue&type=template&id=3fc5b32c&scoped=true"
import script from "./BaggageInformationApp.vue?vue&type=script&lang=js"
export * from "./BaggageInformationApp.vue?vue&type=script&lang=js"
import style0 from "./BaggageInformationApp.vue?vue&type=style&index=0&id=3fc5b32c&prod&lang=less"
import style1 from "./BaggageInformationApp.vue?vue&type=style&index=1&id=3fc5b32c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc5b32c",
  null
  
)

export default component.exports